import { render, staticRenderFns } from "./ModalOrganosVigilancia.vue?vue&type=template&id=72951f76"
import script from "./ModalOrganosVigilancia.vue?vue&type=script&lang=js"
export * from "./ModalOrganosVigilancia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72951f76')) {
      api.createRecord('72951f76', component.options)
    } else {
      api.reload('72951f76', component.options)
    }
    module.hot.accept("./ModalOrganosVigilancia.vue?vue&type=template&id=72951f76", function () {
      api.rerender('72951f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/modales/ModalOrganosVigilancia.vue"
export default component.exports